var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"limited"},[_c('dados-beneficiario'),(_vm.isDetalhe)?_c('guia-detalhe',{attrs:{"guia-detalhe":_vm.guia},on:{"voltar":_vm.voltar}}):_c('guia-grid',{on:{"detalhar":_vm.detalhar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }